<template>
  <div class="w-full relative" style="height: 400px">
    <SmartInfiniteCursorScroll
      :loadMethod="loadMethod"
      :pageSize="pageSize"
      :height="height"
      :listField="'recipientChannelList'"
      ref="scrollRef"
      class="absolute inset-0"
    >
      <template #default="{ item }">
        <label
          @click="handleCheck(item)"
          class="flex items-center gap-2 py-2 cursor-pointer"
        >
          <i
            v-if="isChecked(item)"
            class="el-icon-circle-check text-yellow-500 w-4 h-4"
          />
          <i v-else class="rounded-full border w-4 h-4 inline-block" />
          <slot :item="item">
            <span>
              {{ item.recipient_name }}
              <span v-if="item.channel"> ({{ item.channel }})</span>
            </span>
          </slot>
        </label>
      </template>
    </SmartInfiniteCursorScroll>
  </div>
</template>

<script>
import SmartInfiniteCursorScroll from "./SmartInfiniteCursorScroll.vue";

export default {
  name: "RecipientChannelCheckboxGroup",
  components: {
    SmartInfiniteCursorScroll,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    loadMethod: {
      type: Function,
      required: true,
    },
    valueField: {
      type: String,
      default: "recipient_channel_id",
    },
    labelField: {
      type: String,
      default: "recipient_name",
    },
    pageSize: {
      type: Number,
      default: 20,
    },
    height: {
      type: Number,
      default: 320,
    },
  },
  data() {
    return {
      scrollRef: null,
    };
  },
  methods: {
    isChecked(item) {
      if (!Array.isArray(this.value)) return false;
      // 支持 value 为对象数组或基础类型数组
      return this.value.some((val) => {
        if (val && typeof val === 'object') {
          return val[this.valueField] === item[this.valueField];
        }
        return val === item[this.valueField];
      });
    },
    handleCheck(item) {
      let arr = Array.isArray(this.value) ? [...this.value] : [];
      const idx = arr.findIndex((val) => {
        if (val && typeof val === 'object') {
          return val[this.valueField] === item[this.valueField];
        }
        return val === item[this.valueField];
      });
      if (idx === -1) {
        arr.push(item);
      } else {
        arr = arr.filter((val, i) => i !== idx);
      }
      this.$emit('input', arr);
    },
  },
  watch: {
    value() {
      // 可根据需要刷新滚动组件
    },
  },
};
</script>
